var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _circle2, _rect18, _rect19, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55078,
    y: 1.35449,
    width: 3,
    height: 20.1981,
    rx: 1.5,
    transform: "rotate(-12.2792 1.55078 1.35449)",
    fill: "#19AA59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6797,
    y: 7.80176,
    width: 3,
    height: 13.0115,
    rx: 1.5,
    transform: "rotate(13.2874 25.6797 7.80176)",
    fill: "#19AA59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 21,
    width: 3,
    height: 20.2212,
    rx: 1.5,
    transform: "rotate(-89.9275 5.6875 21)",
    fill: "#19AA59"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6875,
    y: 11,
    width: 3,
    height: 23.462,
    rx: 1.5,
    transform: "rotate(-89.9275 4.6875 11)",
    fill: "#19AA59"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 10.6875 20)",
    fill: "#19AA59"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 8.6875 20)",
    fill: "#19AA59"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 13,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 13)",
    fill: "#19AA59"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 15,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 15)",
    fill: "#19AA59"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6875,
    y: 17,
    width: 1,
    height: 20,
    rx: 0.5,
    transform: "rotate(-90 5.6875 17)",
    fill: "#19AA59"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 12.6875 20)",
    fill: "#19AA59"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 14.6875 20)",
    fill: "#19AA59"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 16.6875 20)",
    fill: "#19AA59"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 18.6875 20)",
    fill: "#19AA59"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 20.6875 20)",
    fill: "#19AA59"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 22.6875 20)",
    fill: "#19AA59"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.6875,
    y: 20,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-180 24.6875 20)",
    fill: "#19AA59"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 2.45215,
    width: 1.44856,
    height: 3.80905,
    rx: 0.724279,
    transform: "rotate(-89.9275 0 2.45215)",
    fill: "#19AA59"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1875,
    cy: 23.5,
    r: 2.5,
    fill: "#19AA59"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1875,
    cy: 23.5,
    r: 2.5,
    fill: "#19AA59"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6875,
    width: 13,
    height: 12.4348,
    rx: 6.21739,
    fill: "#19AA59"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6875,
    width: 13,
    height: 12.4348,
    rx: 6.21739,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2336 8.7014C25.8331 9.20337 25.0701 9.20319 24.6699 8.70104L23.6588 7.43247C23.4192 7.13189 22.9627 7.1311 22.7221 7.43085C22.5466 7.64956 22.546 7.96073 22.7208 8.18004L24.6695 10.625C25.0699 11.1273 25.8332 11.1273 26.2335 10.625L31.6583 3.81868C31.832 3.60068 31.832 3.29153 31.6583 3.07354C31.419 2.77336 30.9629 2.77326 30.7235 3.07332L26.2336 8.7014Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCart);
export default __webpack_public_path__ + "static/media/GreenCart.10c09ec2647944fa5c269b819e2aa356.svg";
export { ForwardRef as ReactComponent };